package one.healthium.ui.components.question

data class QuestionUiModel(
    val id: String,
    val kind: String?,
    val question: String?,
    val allowedStatuses: List<AnswerStatus>,
    val answers: List<AnswerUiModel>,
)

data class AnswerUiModel(
    val id: String,
    val text: String,
    val status: AnswerStatus,
) {
    val selected: Boolean = status != AnswerStatus.None
    val displayValue: String = "${status.displayValue} $text".trim()
}

enum class AnswerStatus {
    Included,
    Excluded,
    None;

    fun next(allowed: List<AnswerStatus>): AnswerStatus {
        return when (this) {
            Included -> Excluded.takeIf { allowed.contains(it) } ?: None
            Excluded -> None
            None -> Included.takeIf { allowed.contains(it) } ?: Excluded.takeIf { allowed.contains(it) } ?: None
        }
    }
}

private val AnswerStatus.displayValue: String
    get() = when (this) {
        AnswerStatus.Included -> "+"
        AnswerStatus.Excluded -> "⨯"
        AnswerStatus.None -> ""
    }